/*
 * Lazy axios wrapper.
 *
 * axios weighs ~13 KB gzipped. Importing it eagerly drags that into the
 * main bundle even for landing visitors who never hit the API. Instead we
 * load it on the first `api.get(...)` call — the resulting chunk ships
 * separately and is skipped entirely for unauthenticated landing loads
 * (no token → no /auth/me call → no axios).
 *
 * Every consumer uses only the HTTP verb methods and treats them as
 * returning a Promise, so proxying them through `getAxios().then(a => a.verb(...))`
 * preserves the existing contract.
 */
let axiosPromise;

function getAxios() {
  if (!axiosPromise) {
    axiosPromise = import(/* webpackChunkName: "axios" */ 'axios').then(mod => {
      const axios = mod.default;
      const instance = axios.create({ baseURL: '/api' });

      instance.interceptors.request.use(cfg => {
        const token = localStorage.getItem('token');
        if (token) cfg.headers.Authorization = `Bearer ${token}`;
        return cfg;
      });

      instance.interceptors.response.use(
        r => r,
        err => {
          if (err.response?.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/login';
          }
          return Promise.reject(err);
        }
      );

      return instance;
    });
  }
  return axiosPromise;
}

const api = {
  get:    (...args) => getAxios().then(a => a.get(...args)),
  post:   (...args) => getAxios().then(a => a.post(...args)),
  put:    (...args) => getAxios().then(a => a.put(...args)),
  delete: (...args) => getAxios().then(a => a.delete(...args)),
  patch:  (...args) => getAxios().then(a => a.patch(...args)),
};

export default api;
